<template>
  <div>
    <el-container> <!-- 总 -->
      <el-header class="m-header" style="display:flex;padding-left:0;padding-right: 0;"> <!-- 设置flex，内边距，字体大小 -->
        <!-- 测试侧边的空隙 -->

        
        <div class="m-aHeaderAside">
          <el-button size="mediun" class="min-YK" @click="fun31">{{ text1 }}</el-button>
          <div class="max-YK">云酷小课堂</div>
        </div> <!-- 顶在最左边 -->
      

        <el-menu mode="horizontal" class="headmenu1" background-color="#F8F8FF" active-text-color="#409eff">
          <el-menu-item index="1" @click="show32(), fun()" class="m-item">首次使用教程</el-menu-item>
          <el-menu-item index="2" @click="show32(), fun2()" class="m-item">运营必知</el-menu-item>
          <!-- <el-menu-item index="3" @click="show32(), fun3()" class="m-item">硬件维修</el-menu-item> -->
        </el-menu>
      </el-header>
      <!-- </el-container> 头部 -->

      <el-container> <!-- 主体. -->
        <div :class="{ asideShow1: asideisshow1 }"> <!-- 侧边栏的显示与否 -->
          <div :class="{ show: isshow }"> <!-- 显示哪列侧边栏 --> <!-- 首次使用教程 -->
            <el-aside class="m-aside" width="250px">
              <!-- 左侧菜单栏 -->
              <el-menu unique-opened="true" background-color="#F8F8FF" style="min-height:93vh" router
                :default-active="floor"> <!--default-active="/final/ReplaceBattery"-->

                <div>
                  <el-menu-item @click="hide33" index="/final/CabinetShow" >
                      <i class="el-icon-num1"></i>骑手换电流程演示</el-menu-item>
                  <el-submenu index="1">

                  <template slot="title"><i class="el-icon-chuci"></i>首次，电脑必设项目</template>

                  <el-menu-item @click="hide33" index="/final/NewDeposit">
                    <i class="el-icon-num1"></i>新建押金</el-menu-item>
                  
                  <el-menu-item @click="hide33" index="/final/InputBattery">
                    <i class="el-icon-num1"></i>录入电池</el-menu-item>
                  
                  <el-menu-item @click="hide33" index="/final/NewCombo">
                    <i class="el-icon-num1"></i>新建套餐</el-menu-item>
                </el-submenu>

                  <el-submenu index="2" >
                    <template slot="title"><i class="el-icon-chuci"></i>柜子安装教程</template>

                    <el-menu-item @click="hide33" index="/final/Adminapp">
                      <i class="el-icon-num1"></i>下载管理端app</el-menu-item>

                    <el-menu-item @click="hide33" index="/final/WiringSize">
                      <i class="el-icon-num1"></i>接线大小详解</el-menu-item>

                    <el-menu-item @click="hide33" index="/final/WiringMethod">
                      <i class="el-icon-num1"></i>通电接线方法</el-menu-item>

                    <el-menu-item @click="hide33" index="/final/DeviceNo">
                      <i class="el-icon-num1"></i>查看设备号</el-menu-item>

                    <el-submenu>
                      <template slot="title"><i class="el-icon-num2"></i>开门方法</template>
                      <el-menu-item @click="hide33" index="/final/AppOpen">
                      <i class="el-icon-num1"></i>手机开仓门</el-menu-item>

                      <el-menu-item @click="hide33" index="/final/WebOpen">
                      <i class="el-icon-num1"></i>电脑开仓门</el-menu-item>

                      <el-menu-item @click="hide33" index="/final/LcdOpen">
                      <i class="el-icon-num1"></i>液晶屏开仓门</el-menu-item>

                      <el-menu-item @click="hide33" index="/final/LockOpen">
                      <i class="el-icon-num1"></i>按锁开仓门</el-menu-item>
                    </el-submenu>

                    <el-menu-item @click="hide33" index="/final/Aerial"><i class="el-icon-num3"></i>天线安装方法</el-menu-item>
                  </el-submenu>
                </div>

                <el-submenu index="3">
                  <template slot="title"><i class="el-icon-chuci"></i>首次，手机设置要求</template>

                  <el-menu-item @click="hide33" index="/final/DevicePositioning">
                    <i class="el-icon-num1"></i>设置设备定位</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/kehuanbi">
                    <i class="el-icon-num1"></i>设置可换比</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/ReadBattery">
                    <i class="el-icon-num1"></i>确认电池是否可用</el-menu-item>
                </el-submenu>

                <el-submenu index="4">
                  <template slot="title"><i class="el-icon-chuci"></i>亲身体验换电</template>

                  <el-menu-item @click="hide33" index="/final/BuyDeposit">
                    <i class="el-icon-num1"></i>如何购买押金，套餐</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/CabinetShow">
                    <i class="el-icon-num1"></i>如何换电</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/BatteryPower">
                    <i class="el-icon-num1"></i>如何看电池电量</el-menu-item>

                    <el-menu-item @click="hide33" index="/final/CabinetLocation">
                    <i class="el-icon-num1"></i>如何看柜子位置</el-menu-item>
                    
                  <el-submenu index="4-1">
                    <template slot="title">如何退租</template>
                      
                    <el-menu-item @click="hide33" index="/final/ReturnsBattery">
                      <i class="el-icon-num1"></i>1，退电池</el-menu-item>
                    <el-menu-item @click="hide33" index="/final/DepositRefund">
                      <i class="el-icon-num1"></i>2，申请退押金</el-menu-item>
                    <el-menu-item @click="hide33" index="/final/ReviewDeposit">
                      <i class="el-icon-num1"></i>3，管理员，审核退押金</el-menu-item>
                  </el-submenu>
                </el-submenu>

                <el-submenu index="5">
                  <template slot="title"><i class="el-icon-chuci"></i>实名 和 合同</template>

                  <el-menu-item @click="hide33" index="/final/name">
                    <i class="el-icon-num1"></i>如何设置实名</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/Contract">
                    <i class="el-icon-num1"></i>和骑手，线上签合同</el-menu-item>

                </el-submenu>

              </el-menu>
            </el-aside>
          </div> <!-- 显示哪列侧边栏 -->

          <div :class="{ show: isshow2 }"> <!-- 显示哪列侧边栏 --> <!-- 换电运营必知 -->
            <el-aside class="m-aside" width="250px">
              <!-- 左侧菜单栏 -->
              <el-menu unique-opened="true" background-color="#F8F8FF" style="min-height:93vh" router
                :default-active="floor"> <!--default-active="/final/ReplaceBattery"-->
                  
                  <el-submenu index="1">
                    <template slot="title"><i class="el-icon-chuci"></i>领电池教程</template>

                    <el-menu-item @click="hide33" index="/final/WhenBindBirder" >
                      <i class="el-icon-num1"></i>什么时候，操作“领电池”</el-menu-item>

                    <el-menu-item @click="hide33" index="/final/HowBindBirder" ><i class="el-icon-num3"></i>如何，操作“领电池”</el-menu-item>
                  </el-submenu>
                
                <el-submenu index="2">
                  <template slot="title"><i class="el-icon-chuci"></i>解绑电池教程</template>
                  <el-menu-item @click="hide33" index="/final/UnBindBattery" >
                      <i class="el-icon-num1"></i>电脑，操作“解绑电池”</el-menu-item>
                  
                  <el-menu-item @click="hide33" index="/final/AppUnBindBattery" >
                      <i class="el-icon-num1"></i>手机，操作“解绑电池”</el-menu-item>
                </el-submenu>

                <el-submenu index="3">
                  <template slot="title"><i class="el-icon-chuci"></i>绑押金、套餐</template>
                  <el-menu-item @click="hide33" index="/final/BindDeposit" >
                      <i class="el-icon-num1"></i>电脑，绑押金</el-menu-item>
                  
                  <el-menu-item @click="hide33" index="/final/AppBindDeposit" >
                      <i class="el-icon-num1"></i>手机，绑押金</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/BindCombo" >
                      <i class="el-icon-num1"></i>电脑，绑套餐</el-menu-item>
                  <el-menu-item @click="hide33" index="/final/AppBindCombo" >
                      <i class="el-icon-num1"></i>手机，绑套餐</el-menu-item>
                </el-submenu>

                <el-menu-item @click="hide33" index="/final/ReviseCombo" >
                      <i class="el-icon-num1"></i>帮骑手，修改套餐天数</el-menu-item>

                <el-submenu index="4">
                  <template slot="title"><i class="el-icon-chuci"></i>退押金合集</template>
                  <el-menu-item @click="hide33" index="/final/ReviewDeposit" >
                      <i class="el-icon-num1"></i>电脑，审核退押金</el-menu-item>
                  <el-menu-item @click="hide33" index="/final/AppReviewDeposit" >
                      <i class="el-icon-num1"></i>手机，审核退押金套餐</el-menu-item>

                  <el-menu-item @click="hide33" index="/final/OnLine" >
                      <i class="el-icon-num1"></i>线上押金转线下</el-menu-item>
                  <el-menu-item @click="hide33" index="/final/OfflineDepositRefund" >
                      <i class="el-icon-num1"></i>线下退押金</el-menu-item>
                  <el-menu-item @click="hide33" index="/final/AppOfflineDeposit" >
                      <i class="el-icon-num1"></i>手机，线下退押金</el-menu-item>    
                </el-submenu>

                <el-submenu index="5">
                  <template slot="title"><i class="el-icon-chuci"></i>修改押金</template>
                  <el-menu-item @click="hide33" index="/final/ReviseDeposit" >
                      <i class="el-icon-num1"></i>修改押金金额</el-menu-item>
                  <el-menu-item @click="hide33" index="/final/OffDeposit" >
                      <i class="el-icon-num1"></i>押金显示开关</el-menu-item>   
                </el-submenu>


                

              </el-menu>
            </el-aside>
          </div> <!-- 显示哪列侧边栏 -->

          <div :class="{ show: isshow3 }"> <!-- 显示哪列侧边栏 --> <!-- 充电硬件维修 -->
            <el-aside width="250px">
              <el-menu unique-opened="true" background-color="#F8F8FF" style="min-height:100vh">

                <el-submenu index="8">
                  <template slot="title"><i class="el-icon-chuci"></i>硬件更换（换电柜）</template>
                  <el-menu-item @click="hide33" index="/final/OffDeposit" >
                      <i class="el-icon-num1"></i>押金显示开关</el-menu-item>
                </el-submenu>

                

              </el-menu>
            </el-aside>
          </div> <!-- 显示哪列侧边栏 -->
        </div> <!-- 侧边栏的显示与否 -->

        <el-main class="m-main">
          <router-view></router-view>
        </el-main>
      </el-container> <!-- 主体 -->
    </el-container><!-- 总 -->

  </div>
</template>

<script>
export default {
  name: "final",
  data() {
    return {
      kuan: document.body.clientWidth,
      isshow: false,
      isshow2: true,
      isshow3: true,
      asideisshow1: true,
      text1: '点击展开侧边栏',
      floor: this.$route.path,
      hardware: [
        {
          title: '1，通电/接线教程',
          path: '/final/EnergizingADevice',
          children: []
        },
        {
          title: '2，如何查看设备号',
          path: '/final/DeviceNumber',
          children: []
        },
        {
          title: '3，添加设备号（挂靠）',
          path: '/final/AddNumber',
          children: []
        },
        {
          title: '4，开门教程',
          path: '/final/opendoor',
          children: []
        },
        {
          title: '5，安装天线',
          path: '/final/antennae',
          children: []
        },
        {
          title: '雨棚/摄像头安装教程',
          path: '/final/camera',
          children: []
        },
      ],
      software: [
        {
          title: '1，什么是电池BT码',
          path: '/final/WhatBt',
          children: []
        },
        {
          title: '2，如何查看电池BT码',
          path: '/final/WachBt',
          children: []
        },
        {
          title: '3，录入电池教程',
          path: '/final/BmsEnter',
          children: []
        },
        {
          title: '4，建立押金教程',
          path: '/final/BuildDeposit',
          children: []
        },
        {
          title: '5，建立套餐教程',
          path: '/final/BuildPackage',
          children: []
        },
        {
          title: '6，设置可换比教程',
          path: '/final/LendRatio',
          children: []
        },
        {
          title: '电柜定位教程',
          path: '/final/Position',
          children: []
        },
      ],
      useruse: [
        {
          title: '1，如何查看ID号',
          path: '/final/UserID',
          children: []
        },
        {
          title: '2，如何买押金',
          path: '/final/BuyDeposit',
          children: []
        },
        {
          title: '3，骑手如何换电',
          path: '/final/BuyDeposit',
          children: []
        },
      ],
      depositAndPackage: [
        {
          title: '什么时候要操作"领电池"',
          path: '/final/HowBindBatter',
          children: []
        },
        {
          title: '如何操作“领电池”',
          path: '/final/BindBatter',
          children: []
        },
        {
          title: '什么时候要操作"退电池"',
          path: '/final/HowRelieveBatter',
          children: []
        },
        {
          title: '如何操作“退电池”',
          path: '/final/RelieveBatter',
          children: []
        }
      ],
      operateBattery: [
        {
          title: '后台绑押金',
          path: '/final/BindDeposit',
          children: []
        },
        {
          title: '后台绑套餐',
          path: '/final/BindPackage',
          children: []
        },
        {
          title: '修改月租天数',
          path: '/final/AddRent',
          children: []
        },
        {
          title: '修改套餐天数',
          path: '/final/RevisePackage',
          children: []
        }
      ],
      repair: [
        {
          title: '如何换锁',
          path: '/final/ReplacementLock',
          children: []
        },
        {
          title: '如何拆充电线',
          path: '/final/RemoveChargingLine',
          children: []
        },
        {
          title: '如何装充电线',
          path: '/final/InstalChargingLine',
          children: []
        },
        {
          title: '如何拆充电器',
          path: '/final/RemoveCharger',
          children: []
        },
        {
          title: '如何拆分板',
          path: '/final/RemoveFenPcb',
          children: []
        }
      ]
    }
  },
  // 挂载时
  mounted() {
    if (this.kuan > 768) {
      if (this.floor === "/final/EnergizingADevice" || this.floor === "/final/DeviceNumber") {
        this.$nextTick(() => {
          this.$intro()
          .setOptions({
            prevLabel: '上一步',
            nextLabel: '下一步',
            skipLabel: '退出',
            doneLabel: '开始体验',
            hidePrev: 'true',
            hideNext: 'false',
            exitOnOverlayClick: 'false'
          })
          .start()
        }
        )
      }
    } else {
      this.$nextTick(() => {
        this.$intro()
        .setOptions({
          prevLabel: '上一步',
          nextLabel: '下一步',
          skipLabel: '退出',
          doneLabel: '开始体验',
          hidePrev: 'true',
          hideNext: 'false',
          exitOnOverlayClick: 'false',
          steps: [{
            element: document.querySelector('.m-aHeaderAside'),
            title: '可点击',
            intro: '点击，可看更多教程',
            position: 'right',
            tooltipClass: "introjs-tooltip",
            highlightClass: "introjs-highlight",
          },]
        })
        .start()
      }
      )
    }
  },
  methods: {
    fun() {
      this.isshow = false
      this.isshow2 = true
      this.isshow3 = true
    },
    fun2() {
      this.isshow2 = false
      this.isshow = true
      this.isshow3 = true
    },
    fun3() {
      this.isshow3 = false
      this.isshow = true
      this.isshow2 = true
    },
    fun31() {
      if (this.asideisshow1 === true) {
        this.asideisshow1 = false
        this.text1 = '隐藏侧边栏'  /*侧边栏出现*/
      } else {
        this.asideisshow1 = true
        this.text1 = '点击展开侧边栏'
      }
    },
    show32() {
      this.asideisshow1 = false
      this.text1 = '隐藏侧边栏'
    },
    hide33() {
      this.asideisshow1 = true
      this.text1 = '点击显示侧边栏'
    }
  }
}
</script>


<style  scoped>
.el-icon-num1 {
  background: url(../assets/num1.png) center no-repeat;
  background-size: cover;
}

.el-icon-num1:before {
  content: "1";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-num2 {
  background: url(../assets/num2.png) center no-repeat;
  background-size: cover;
}

.el-icon-num2:before {
  content: "2";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-num3 {
  background: url(../assets/num3.png) center no-repeat;
  background-size: cover;
}

.el-icon-num3:before {
  content: "3";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-num4 {
  background: url(../assets/num4.png) center no-repeat;
  background-size: cover;
}

.el-icon-num4:before {
  content: "4";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-num5 {
  background: url(../assets/num5.png) center no-repeat;
  background-size: cover;
}

.el-icon-num5:before {
  content: "5";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-erji {
  background: url(../assets/myicon2.png) center no-repeat;
  background-size: cover;
}

.el-icon-erji:before {
  content: "好";
  font-size: 16px;
  visibility: hidden;
}

.el-icon-chuci {
  background: url(../assets/myicon3.png) center no-repeat;
  background-size: cover;
}

.el-icon-chuci:before {
  content: "你";
  font-size: 16px;
  visibility: hidden;
}

.el-menu-item.is-active {
  background-color: rgb(202, 225, 247) !important;
}

/*.el-menu-item.is-active {
    background-color: rgb(6, 141, 47) !important;
  }*/
/* 修改选中项的背景色 */
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.show {
  display: none;
}

@media(max-width:768px) {

  /* 小屏 */
  .m-main {
    padding-top: 0px !important;
  }

  .m-item {
    height: 28px !important;
    line-height: 28px !important;
  }

  .m-header {
    font-size: 20px;
    height: 28px !important;
  }

  .m-aHeaderAside {
    height: 28px;
    background: rgb(144, 200, 245);
    width: 250px;
    /*text-align: center;*/
    display: flex;
    justify-content: center;
  }

  .min-YK {
    background-color: aqua !important;
    height: 28px;
    /*line-height:7px;*/
    padding-top: 7px !important;
    /*display: none !important;  /* 大屏时隐藏 */
  }

  .max-YK {
    display: none;
    /* 小屏时隐藏 */
  }

  .asideShow1 {
    display: none !important;
  }

  .headmenu1 {
    /* 头部菜单栏 */
    width: 750px;
  }
}

@media screen and (min-width:769px) {
  .m-aside {
    height: calc(100vh - 60px) !important;
    overflow-y: auto;
  }

  .m-main {
    height: calc(100vh - 60px) !important;
    overflow-y: auto;
  }

  .min-YK {
    display: none !important;
    /* 大屏时隐藏按钮 */
  }

  .m-header {
    font-size: 20px;
    height: 60px !important;
  }

  .m-aHeaderAside {
    height: 60px;
    background: rgb(144, 200, 245);
    width: 250px;
    text-align: center;
    /*display: flex; 注意和下面那个的区别*/
    position: absolute;
    justify-content: center;
    padding-top: 15px;
  }

  .m-item {
    /* 控制换电，充电字体居中 */
    height: 60px;
    line-height: 70px;
  }

  .headmenu1 {
    /* 头部菜单栏 */
    width: 100%;
    margin-left: 250px !important;
  }
}</style>

<style>/* .el-submenu__title{
  color: red !important;
   background-color: aqua !important; 
}*/
/* .el-menu--horizontal .el-menu .el-sub-menu_title {
  color: rgb(172, 16, 16) !important;} */</style>